import type { CoordinatesDto } from "@/api/dto/coordinates.dto";

export const useGoogleMap = () => {
  const getApiKey = (): string => {
    return import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  };

  const getPlaceUrl = (location: CoordinatesDto, zoom: number = -1): string => {
    if (!location) return "#";

    let url = `https://www.google.com/maps/place/${location.lat},${location.lon}`;

    if (zoom > 0) {
      url += `/@${location.lat},${location.lon},${zoom}z`;
    }

    return url;
  };

  const getRouteUrl = (location1: CoordinatesDto, location2: CoordinatesDto): string => {
    if (!location1 || !location2) return "#";

    const baseUrl = "https://www.google.com/maps/dir/?api=1&travelmode=driving";
    return `${baseUrl}&origin=${location1.lat},${location1.lon}&destination=${location2.lat},${location2.lon}`;
  };

  const getPlaceUrlByAddress = (address?: string | null): string => {
    if (!address) return "#";

    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
  };

  return {
    getApiKey,
    getPlaceUrl,
    getRouteUrl,
    getPlaceUrlByAddress,
  };
};
